// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"b415b8ed","689":"ab175e6c"}[chunkId] + ".chunk.js";
};